import { module } from 'angular';
import templateBuilderRepreDisplay from './builder/display.html';
import templateBuilderRepreValidate from './builder/validate.html';
import templateBuilderRepreAPI from './builder/api.html';

export default module('app').run(/* @ngInject */ (
	/** @type {import('angular').ITemplateCacheService} */ $templateCache,
) => {
	$templateCache.put('kform/components/repre/display.html', templateBuilderRepreDisplay);
	$templateCache.put('kform/components/repre/validate.html', templateBuilderRepreValidate);
	$templateCache.put('kform/components/repre/api.html', templateBuilderRepreAPI);
});
